module.exports = __webpack_public_path__ + "static/media/icons.54358f12.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@automotivetech/icons/dist/static/media/icons.svg
// module id = 350
// module chunks = 0